var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _g2, _path55, _g3, _path56, _g4, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g5, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 269,
    viewBox: "0 0 258 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.018 220.155H60.4012C35.9757 220.155 14.0468 204.193 6.23096 180.224C6.05437 179.683 5.88048 179.134 5.7086 178.578C-1.05509 156.687 -4.72778 131.18 17.7511 97.0873C40.2301 62.9938 24.8101 31.0154 53.7116 19.3738C82.6132 7.73234 106.061 22.2485 138.976 8.11248C171.891 -6.02354 237.723 -5.1918 241.736 52.184C245.751 109.561 229.694 107.065 236.116 126.191C242.539 145.317 264.215 225.145 151.018 220.155Z",
    fill: "#EAF1FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3022 268.502C99.9975 268.502 127.313 261.204 127.313 252.202C127.313 243.2 99.9975 235.902 66.3022 235.902C32.6068 235.902 5.29139 243.2 5.29139 252.202C5.29139 261.204 32.6068 268.502 66.3022 268.502Z",
    fill: "#E4F1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55005 220.115H252.975",
    stroke: "url(#paint0_linear_3079_14443)",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9014 258.376L88.686 258.43C90.3198 258.432 91.6463 257.109 91.6476 255.475L91.7022 205.264L37.9587 205.207L37.9014 258.376Z",
    fill: "#9FCCFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9594 205.204L91.6773 205.262L74.7637 191.783C73.5916 190.849 72.1317 190.339 70.626 190.337L25.6526 190.289C24.5338 190.288 23.9777 191.632 24.7764 192.407L37.9594 205.204Z",
    fill: "#9FCCFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8534 240.809L22.6856 194.61C22.6897 191.09 24.9746 190.514 24.9746 190.514L24.56 191.382C24.3572 191.829 24.7811 192.35 25.1336 192.694L37.9654 205.207L37.9075 258.372L24.5048 244.8C23.4513 243.732 22.8588 242.301 22.8534 240.809Z",
    fill: "#9FCCFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9076 205.222L40.2011 205.209C38.963 205.208 37.958 206.211 37.9567 207.449L37.9418 220.866",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9331 229.352L37.9041 256.132",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0249 197.537L37.8906 205.207",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8997 190.514L24.4852 191.382C24.2823 191.829 24.7063 192.35 25.0588 192.694L28.6459 196.192",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.533 220.381H93.0476C86.7396 220.381 81.6259 215.268 81.6259 208.959V54.3105C81.6259 48.0024 86.7396 42.8887 93.0476 42.8887H163.533C169.841 42.8887 174.955 48.0024 174.955 54.3105V208.959C174.955 215.268 169.841 220.381 163.533 220.381Z",
    fill: "url(#paint1_linear_3079_14443)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.207 215.981H92.3729C88.6719 215.981 85.6712 212.98 85.6712 209.279V53.9888C85.6712 50.2878 88.6719 47.2871 92.3729 47.2871H164.207C167.908 47.2871 170.909 50.2878 170.909 53.9888V209.279C170.909 212.98 167.909 215.981 164.207 215.981Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.462 57.4397H114.119C110.617 57.4397 107.779 54.6015 107.779 51.1V45.4262C107.779 45.2401 107.929 45.0898 108.115 45.0898H148.802V51.1C148.802 54.6015 145.964 57.4397 142.462 57.4397Z",
    fill: "url(#paint2_linear_3079_14443)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.866 37.1372C106.931 48.346 97.897 57.4849 86.6882 57.5496C75.4795 57.6143 66.3405 48.5799 66.2765 37.3717C66.2118 26.1623 75.2456 17.024 86.4544 16.9593C97.6625 16.8946 106.801 25.9284 106.866 37.1372Z",
    fill: "#B4D8F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.676 36.8459C101.725 45.3674 94.858 52.3145 86.3371 52.363C77.8156 52.4122 70.8686 45.5447 70.8194 37.0239C70.7702 28.5023 77.6377 21.5553 86.1585 21.5061C94.68 21.4576 101.627 28.3244 101.676 36.8459Z",
    fill: "#71B7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.116 37.486C102.164 45.8923 95.389 52.747 86.982 52.7948C78.5751 52.8434 71.7217 46.0682 71.6732 37.6613C71.6247 29.2544 78.3998 22.4003 86.8068 22.3518C95.213 22.304 102.067 29.0798 102.116 37.486Z",
    fill: "#FF725E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.116 37.486C102.164 45.8923 95.389 52.747 86.982 52.7948C78.5751 52.8434 71.7217 46.0682 71.6732 37.6613C71.6247 29.2544 78.3998 22.4003 86.8068 22.3518C95.213 22.304 102.067 29.0798 102.116 37.486Z",
    fill: "#8CC2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4931 36.2513L87.4709 32.3569C87.477 32.3569 87.4837 32.3569 87.4898 32.3569C88.1665 32.4311 88.8681 32.6076 89.563 32.8847C90.1434 33.1812 90.5363 33.4906 90.5363 33.4906L90.5869 33.3699L91.1793 31.9646L91.3155 31.6418L90.6172 30.9165L90.2842 31.0689C89.4309 30.6476 88.459 30.3194 87.4588 30.2708L87.4466 28.1288L86.7767 27.5957L86.78 28.1329L85.8647 28.1383L85.8775 30.3187C82.8694 30.6254 81.4513 32.3508 81.4628 34.319C81.4783 37.0008 83.7787 37.6823 85.9227 38.1905L85.9449 42.0492C84.4776 41.9225 83.0272 41.3711 82.0775 40.6048L81.2208 42.5587C82.2291 43.4215 84.0658 44.0281 85.9571 44.1332L85.9665 45.7502L85.2136 45.7677L85.9699 46.2746L87.5518 46.2651L87.539 44.1042C90.566 43.778 92.0036 42.0721 91.9922 40.104C91.976 37.4214 89.6378 36.7595 87.4931 36.2513ZM85.9085 35.855C84.7877 35.5335 83.9553 35.1136 83.9499 34.1875C83.9452 33.3389 84.5201 32.6407 85.8883 32.4209L85.9085 35.855ZM87.5262 42.0007L87.5066 38.5854C88.6659 38.9069 89.5172 39.3457 89.5233 40.2907C89.528 41.1211 88.9335 41.7803 87.5262 42.0007Z",
    fill: "#71B7E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8811 43.5797L86.8939 45.7412L85.3114 45.75L85.2992 43.608C83.4073 43.5028 81.5706 42.8962 80.5623 42.0335L81.4196 40.0802C82.37 40.8465 83.8198 41.3972 85.2878 41.5239L85.2655 37.6645C83.1208 37.1563 80.8204 36.4742 80.8049 33.7923C80.7935 31.8236 82.2116 30.0981 85.2204 29.7914L85.2076 27.611L86.7901 27.6016L86.8023 29.7436C88.2312 29.8123 89.6803 30.2289 90.727 30.8981L89.9465 32.8514C88.9207 32.259 87.8375 31.9375 86.8144 31.8276L86.8366 35.7254C88.982 36.2343 91.3208 36.8962 91.3363 39.5781C91.3464 41.5468 89.9088 43.2534 86.8811 43.5797ZM85.2507 35.3298L85.2311 31.895C83.8622 32.1154 83.2873 32.813 83.2927 33.6623C83.2974 34.5884 84.1298 35.0083 85.2507 35.3298ZM88.8661 39.7668C88.8607 38.8211 88.0087 38.3824 86.8494 38.0609L86.869 41.4767C88.2763 41.2563 88.8708 40.5965 88.8661 39.7668Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.572 18.3135C141.613 25.4148 135.89 31.2046 128.789 31.2457C121.688 31.2868 115.898 25.5631 115.857 18.4618C115.816 11.3604 121.539 5.57062 128.641 5.52951C135.741 5.48907 141.531 11.2121 141.572 18.3135Z",
    fill: "#B4D8F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M138.284 18.1289C138.315 23.5277 133.965 27.929 128.567 27.96C123.168 27.991 118.766 23.6403 118.735 18.2414C118.704 12.8426 123.055 8.44133 128.454 8.41032C133.852 8.37932 138.253 12.7301 138.284 18.1289Z",
    fill: "#71B7E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M138.562 18.5352C138.593 23.8613 134.3 28.2039 128.974 28.2342C123.648 28.2652 119.306 23.9725 119.275 18.6464C119.244 13.3204 123.537 8.97843 128.863 8.94743C134.19 8.91709 138.532 13.2092 138.562 18.5352Z",
    fill: "#FF725E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.562 18.5352C138.593 23.8613 134.3 28.2039 128.974 28.2342C123.648 28.2652 119.306 23.9725 119.275 18.6464C119.244 13.3204 123.537 8.97843 128.863 8.94743C134.19 8.91709 138.532 13.2092 138.562 18.5352Z",
    fill: "#8CC2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.299 17.7526L129.284 15.2857C129.288 15.2857 129.292 15.2857 129.297 15.2857C129.725 15.3329 130.17 15.4448 130.61 15.62C130.978 15.8081 131.227 16.0042 131.227 16.0042L131.259 15.9281L131.635 15.0377L131.721 14.8328L131.279 14.3731L131.068 14.4695C130.527 14.2026 129.911 13.9943 129.278 13.964L129.27 12.6072L128.846 12.2695L128.848 12.6099L128.268 12.6133L128.276 13.9943C126.37 14.1884 125.472 15.2817 125.479 16.5286C125.489 18.2278 126.946 18.6592 128.304 18.982L128.319 21.4266C127.389 21.3464 126.47 20.9973 125.869 20.512L125.326 21.7495C125.965 22.2961 127.128 22.6803 128.327 22.747L128.333 23.7715L127.855 23.7823L128.335 24.1038L129.337 24.0984L129.329 22.7295C131.247 22.5233 132.158 21.4421 132.15 20.1952C132.139 18.494 130.657 18.0748 129.299 17.7526ZM128.295 17.5019C127.585 17.2983 127.057 17.0321 127.054 16.4457C127.051 15.9078 127.415 15.4657 128.282 15.3262L128.295 17.5019ZM129.319 21.3956L129.307 19.2321C130.042 19.4356 130.581 19.714 130.585 20.3125C130.587 20.8382 130.211 21.2561 129.319 21.3956Z",
    fill: "#71B7E2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.911 22.3951L128.919 23.7647L127.916 23.7701L127.908 22.4133C126.71 22.3466 125.546 21.9624 124.907 21.4158L125.45 20.1783C126.052 20.6636 126.971 21.0127 127.901 21.0929L127.887 18.6476C126.528 18.3254 125.071 17.8934 125.061 16.1942C125.053 14.9473 125.952 13.8534 127.858 13.6593L127.85 12.2775L128.852 12.2715L128.859 13.6283C129.765 13.6721 130.683 13.9356 131.346 14.3596L130.852 15.5971C130.202 15.2216 129.516 15.0181 128.867 14.948L128.882 17.4176C130.24 17.7397 131.723 18.159 131.732 19.8588C131.74 21.1071 130.829 22.1882 128.911 22.3951ZM127.878 17.1682L127.865 14.9918C126.998 15.1313 126.634 15.5735 126.637 16.1113C126.641 16.6984 127.168 16.9646 127.878 17.1682ZM130.168 19.9795C130.165 19.3803 129.625 19.1026 128.89 18.899L128.902 21.0633C129.795 20.9231 130.172 20.5052 130.168 19.9795Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M223.784 143.489H254.734C256.244 143.489 257.47 142.265 257.47 140.754V108.783C257.47 107.272 256.245 106.047 254.734 106.047H223.784C222.273 106.047 221.048 107.272 221.048 108.783V140.754C221.048 142.265 222.273 143.489 223.784 143.489Z",
    fill: "#9FCCFB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M254.733 106.049H223.783C222.272 106.049 221.048 107.273 221.048 108.785V116.83H257.468V108.785C257.469 107.273 256.244 106.049 254.733 106.049Z",
    fill: "url(#paint3_linear_3079_14443)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M247.442 126.173H252.308C252.601 126.173 252.839 125.936 252.839 125.643V120.777C252.839 120.483 252.601 120.246 252.308 120.246H247.442C247.149 120.246 246.911 120.484 246.911 120.777V125.643C246.911 125.936 247.149 126.173 247.442 126.173Z",
    fill: "#E4F1FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M240.49 126.173H245.357C245.65 126.173 245.887 125.936 245.887 125.643V120.777C245.887 120.483 245.649 120.246 245.357 120.246H240.49C240.197 120.246 239.96 120.484 239.96 120.777V125.643C239.96 125.936 240.197 126.173 240.49 126.173Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M230.594 108.849C229.924 108.849 229.38 108.306 229.38 107.635V103.337C229.38 102.666 229.924 102.123 230.594 102.123C231.264 102.123 231.808 102.666 231.808 103.337V107.635C231.808 108.306 231.265 108.849 230.594 108.849Z",
    fill: "#8EC3F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M236.739 108.857C236.069 108.857 235.525 108.314 235.525 107.643V103.345C235.525 102.674 236.069 102.131 236.739 102.131C237.409 102.131 237.953 102.674 237.953 103.345V107.643C237.953 108.314 237.409 108.857 236.739 108.857Z",
    fill: "#8EC3F4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M242.598 108.853C241.928 108.853 241.385 108.31 241.385 107.639V103.341C241.385 102.67 241.928 102.127 242.598 102.127C243.268 102.127 243.812 102.67 243.812 103.341V107.639C243.812 108.31 243.269 108.853 242.598 108.853Z",
    fill: "#8EC3F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M233.49 126.173H238.356C238.649 126.173 238.887 125.936 238.887 125.643V120.777C238.887 120.483 238.649 120.246 238.356 120.246H233.49C233.197 120.246 232.959 120.484 232.959 120.777V125.643C232.959 125.936 233.197 126.173 233.49 126.173Z",
    fill: "#E4F1FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226.538 126.173H231.404C231.698 126.173 231.935 125.936 231.935 125.643V120.777C231.935 120.483 231.697 120.246 231.404 120.246H226.538C226.245 120.246 226.008 120.484 226.008 120.777V125.643C226.008 125.936 226.246 126.173 226.538 126.173Z",
    fill: "#E4F1FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M247.391 132.773H252.258C252.551 132.773 252.788 132.535 252.788 132.243V127.376C252.788 127.083 252.551 126.846 252.258 126.846H247.391C247.098 126.846 246.861 127.084 246.861 127.376V132.243C246.861 132.535 247.098 132.773 247.391 132.773Z",
    fill: "#E4F1FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M240.44 132.773H245.306C245.599 132.773 245.836 132.535 245.836 132.243V127.376C245.836 127.083 245.598 126.846 245.306 126.846H240.44C240.146 126.846 239.909 127.084 239.909 127.376V132.243C239.909 132.535 240.147 132.773 240.44 132.773Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233.44 132.773H238.306C238.6 132.773 238.837 132.535 238.837 132.243V127.376C238.837 127.083 238.599 126.846 238.306 126.846H233.44C233.147 126.846 232.91 127.084 232.91 127.376V132.243C232.909 132.535 233.147 132.773 233.44 132.773Z",
    fill: "#E4F1FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M226.488 132.773H231.355C231.648 132.773 231.885 132.535 231.885 132.243V127.376C231.885 127.083 231.647 126.846 231.355 126.846H226.488C226.195 126.846 225.958 127.084 225.958 127.376V132.243C225.958 132.535 226.195 132.773 226.488 132.773Z",
    fill: "#E4F1FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247.342 139.427H252.208C252.502 139.427 252.739 139.189 252.739 138.897V134.03C252.739 133.737 252.501 133.5 252.208 133.5H247.342C247.049 133.5 246.812 133.738 246.812 134.03V138.897C246.812 139.189 247.049 139.427 247.342 139.427Z",
    fill: "#E4F1FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240.39 139.427H245.257C245.55 139.427 245.787 139.189 245.787 138.897V134.03C245.787 133.737 245.549 133.5 245.257 133.5H240.39C240.097 133.5 239.86 133.738 239.86 134.03V138.897C239.86 139.189 240.098 139.427 240.39 139.427Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.391 139.427H238.257C238.55 139.427 238.788 139.189 238.788 138.897V134.03C238.788 133.737 238.55 133.5 238.257 133.5H233.391C233.098 133.5 232.86 133.738 232.86 134.03V138.897C232.86 139.189 233.098 139.427 233.391 139.427Z",
    fill: "#E4F1FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M226.439 139.427H231.305C231.599 139.427 231.836 139.189 231.836 138.897V134.03C231.836 133.737 231.598 133.5 231.305 133.5H226.439C226.146 133.5 225.909 133.738 225.909 134.03V138.897C225.909 139.189 226.146 139.427 226.439 139.427Z",
    fill: "#E4F1FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M248.472 108.853C247.802 108.853 247.258 108.31 247.258 107.639V103.341C247.258 102.67 247.802 102.127 248.472 102.127C249.142 102.127 249.686 102.67 249.686 103.341V107.639C249.686 108.31 249.142 108.853 248.472 108.853Z",
    fill: "#8EC3F4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M196.912 79.625H108.123C105.238 79.625 102.9 81.9638 102.9 84.8486V85.6641V131.055C102.9 133.939 105.238 136.278 108.123 136.278H196.911C199.796 136.278 202.135 133.939 202.135 131.055V122.861V84.8486C202.135 81.9638 199.796 79.625 196.912 79.625Z",
    fill: "#9FCCFB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M194.613 134.462H105.825C102.94 134.462 100.601 132.123 100.601 129.238V83.0322C100.601 80.1474 102.94 77.8086 105.825 77.8086H194.613C197.498 77.8086 199.837 80.1474 199.837 83.0322V129.238C199.837 132.124 197.498 134.462 194.613 134.462Z",
    fill: "#9FCCFB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M199.837 83.0341C199.837 80.1494 197.498 77.8105 194.613 77.8105H105.825C102.94 77.8105 100.601 80.1494 100.601 83.0341V83.8497C111.468 84.3431 132.531 87.9052 147.222 106.766C164.132 128.474 186.855 126.351 199.836 121.046V83.0341H199.837Z",
    fill: "#8EC3F4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 109.396H110.749C109.651 109.396 108.76 108.506 108.76 107.408V100.918C108.76 99.8201 109.651 98.9297 110.749 98.9297H123.143C124.241 98.9297 125.131 99.8201 125.131 100.918V107.408C125.131 108.506 124.242 109.396 123.143 109.396Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.014 87.927H175.067C174.612 87.927 174.244 87.559 174.244 87.1047V83.6504C174.244 83.1961 174.612 82.8281 175.067 82.8281H193.014C193.468 82.8281 193.836 83.1961 193.836 83.6504V87.1047C193.836 87.5583 193.468 87.927 193.014 87.927Z",
    fill: "url(#paint4_linear_3079_14443)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.265 118.24H109.907C108.948 118.24 108.169 117.462 108.169 116.502C108.169 115.542 108.948 114.764 109.907 114.764H125.265C126.225 114.764 127.004 115.541 127.004 116.502C127.004 117.462 126.225 118.24 125.265 118.24Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147.009 118.24H131.651C130.691 118.24 129.913 117.462 129.913 116.502C129.913 115.542 130.691 114.764 131.651 114.764H147.009C147.969 114.764 148.747 115.541 148.747 116.502C148.747 117.462 147.969 118.24 147.009 118.24Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.915 118.24H153.557C152.597 118.24 151.819 117.462 151.819 116.502C151.819 115.542 152.597 114.764 153.557 114.764H168.915C169.875 114.764 170.653 115.541 170.653 116.502C170.653 117.462 169.875 118.24 168.915 118.24Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.658 118.24H175.3C174.34 118.24 173.562 117.462 173.562 116.502C173.562 115.542 174.339 114.764 175.3 114.764H190.658C191.618 114.764 192.396 115.541 192.396 116.502C192.396 117.462 191.618 118.24 190.658 118.24Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.116 129.963H110.139C109.555 129.963 109.082 129.489 109.082 128.906C109.082 128.323 109.556 127.85 110.139 127.85H130.116C130.7 127.85 131.173 128.323 131.173 128.906C131.173 129.489 130.7 129.963 130.116 129.963Z",
    fill: "url(#paint5_linear_3079_14443)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M190.604 129.963H180.747C180.163 129.963 179.69 129.489 179.69 128.906C179.69 128.323 180.163 127.85 180.747 127.85H190.604C191.188 127.85 191.66 128.323 191.66 128.906C191.66 129.489 191.188 129.963 190.604 129.963Z",
    fill: "url(#paint6_linear_3079_14443)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3079_14443",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 98,
    width: 18,
    height: 12
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 109.396H110.749C109.651 109.396 108.76 108.506 108.76 107.408V100.918C108.76 99.8201 109.651 98.9297 110.749 98.9297H123.143C124.241 98.9297 125.131 99.8201 125.131 100.918V107.408C125.131 108.506 124.242 109.396 123.143 109.396Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3079_14443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.747 98.75C113.198 100.614 115.496 104.843 111.553 109.672",
    stroke: "#8EC3F4",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3079_14443",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 98,
    width: 18,
    height: 12
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 109.396H110.749C109.651 109.396 108.76 108.506 108.76 107.408V100.918C108.76 99.8201 109.651 98.9297 110.749 98.9297H123.143C124.241 98.9297 125.131 99.8201 125.131 100.918V107.408C125.131 108.506 124.242 109.396 123.143 109.396Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3079_14443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.706 104.068H113.712",
    stroke: "#8EC3F4",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3079_14443",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 98,
    width: 18,
    height: 12
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 109.396H110.749C109.651 109.396 108.76 108.506 108.76 107.408V100.918C108.76 99.8201 109.651 98.9297 110.749 98.9297H123.143C124.241 98.9297 125.131 99.8201 125.131 100.918V107.408C125.131 108.506 124.242 109.396 123.143 109.396Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3079_14443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.692 98.75C120.242 100.614 117.944 104.843 121.887 109.672",
    stroke: "#8EC3F4",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3079_14443",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 98,
    width: 18,
    height: 12
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M123.143 109.396H110.749C109.651 109.396 108.76 108.506 108.76 107.408V100.918C108.76 99.8201 109.651 98.9297 110.749 98.9297H123.143C124.241 98.9297 125.131 99.8201 125.131 100.918V107.408C125.131 108.506 124.242 109.396 123.143 109.396Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3079_14443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.734 104.068H119.727",
    stroke: "#8EC3F4",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M210.946 40.9596C206.498 36.2955 206.172 34.6677 213.115 27.8339C220.058 21.0001 218.973 11.5626 218.973 11.5626L205.636 11.3058V11.291L205.254 11.2984L204.871 11.291V11.3058L191.534 11.5626C191.534 11.5626 190.45 21.0001 197.392 27.8339C204.334 34.6677 204.009 36.2948 199.562 40.9596C195.114 45.6244 189.04 50.1801 189.257 58.7494H204.871H205.636H221.251C221.468 50.1801 215.393 45.6238 210.946 40.9596Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M221.515 61.0725H188.991C188.002 61.0725 187.202 60.2711 187.202 59.2824C187.202 58.2936 188.003 57.4922 188.991 57.4922H221.515C222.503 57.4922 223.304 58.2936 223.304 59.2824C223.305 60.2718 222.503 61.0725 221.515 61.0725Z",
    fill: "url(#paint7_linear_3079_14443)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M221.515 13.0276H188.991C188.002 13.0276 187.201 12.2262 187.201 11.2374C187.201 10.2487 188.003 9.44727 188.991 9.44727H221.515C222.503 9.44727 223.304 10.2487 223.304 11.2374C223.305 12.2262 222.503 13.0276 221.515 13.0276Z",
    fill: "url(#paint8_linear_3079_14443)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M199.074 25.375H211.695C212.12 25.375 212.352 25.8455 212.078 26.1542L206.339 32.63C206.263 32.7156 206.221 32.8235 206.221 32.9354V52.5235C206.221 52.7857 206.445 52.998 206.722 52.998H217.448C217.667 52.998 217.86 53.1321 217.926 53.3296L218.644 55.4857C218.746 55.7917 218.505 56.1031 218.167 56.1031H192.354C192.026 56.1031 191.787 55.8093 191.87 55.5087L192.469 53.337C192.526 53.1287 192.724 52.9831 192.951 52.9825L204.029 52.944C204.305 52.9434 204.528 52.7311 204.528 52.4695V33.0398C204.528 32.93 204.487 32.8228 204.414 32.7379L198.687 26.1508C198.419 25.8414 198.651 25.375 199.074 25.375Z",
    fill: "#9FCCFB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M202.252 194.675C202.252 194.675 202.367 179.846 211.534 178.785C220.701 177.723 223.859 180.445 225.115 180.949C226.37 181.452 223.064 182.128 220.268 184.863C217.472 187.599 217.5 191.009 211.196 192.125C204.891 193.241 202.545 197.885 202.545 197.885L202.252 194.675Z",
    fill: "url(#paint9_linear_3079_14443)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M202.544 197.886C202.544 197.886 205.483 182.673 219.693 182.055",
    stroke: "url(#paint10_linear_3079_14443)",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 189.405C203.004 189.405 204.377 176.619 196.585 174.796C188.794 172.972 185.803 175.004 184.672 175.313C183.541 175.622 186.321 176.532 188.459 179.166C190.596 181.8 190.233 184.735 195.553 186.322C200.873 187.908 202.434 192.142 202.434 192.142L203.004 189.405Z",
    fill: "url(#paint11_linear_3079_14443)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M202.435 192.141C202.435 192.141 201.412 178.745 189.232 176.803",
    stroke: "url(#paint12_linear_3079_14443)",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M203.854 160.191C203.857 160.191 203.869 160.241 203.887 160.338C203.907 160.447 203.933 160.591 203.966 160.774C204 160.97 204.04 161.206 204.088 161.484C204.123 161.769 204.162 162.095 204.207 162.46C204.367 163.929 204.489 166.076 204.338 168.719C204.213 171.363 203.819 174.491 203.378 177.954C202.932 181.417 202.55 185.24 202.487 189.268C202.308 197.331 203.292 204.604 204.347 209.77C204.859 212.361 205.415 214.426 205.781 215.857C205.977 216.559 206.132 217.108 206.24 217.494C206.288 217.674 206.325 217.816 206.354 217.922C206.378 218.018 206.389 218.069 206.386 218.069C206.386 218.069 205.294 214.978 204.203 209.8C203.108 204.633 202.099 197.346 202.279 189.264C202.341 185.228 202.73 181.393 203.187 177.93C203.639 174.466 204.047 171.347 204.191 168.711C204.359 166.076 204.261 163.937 204.125 162.469C204.088 162.104 204.055 161.778 204.026 161.493C203.986 161.215 203.952 160.977 203.924 160.781C203.9 160.597 203.88 160.452 203.865 160.342C203.855 160.243 203.85 160.192 203.854 160.191Z",
    fill: "url(#paint13_linear_3079_14443)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M212.514 204.576H194.947C194.527 204.576 194.188 204.235 194.188 203.816V201.703C194.188 201.283 194.528 200.943 194.947 200.943H212.514C212.934 200.943 213.274 201.284 213.274 201.703V203.816C213.274 204.235 212.934 204.576 212.514 204.576Z",
    fill: "#21212A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M208.58 219.928H199.529C198.799 219.928 198.174 219.402 198.05 218.682L195.513 203.992H211.949L210.069 218.618C209.974 219.366 209.335 219.928 208.58 219.928Z",
    fill: "#21212A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M203.641 173.814C203.641 173.814 204.887 164.103 210.979 164.131C217.072 164.159 218.927 166.193 219.71 166.621C220.494 167.05 218.273 167.232 216.224 168.805C214.175 170.377 213.925 172.615 209.705 172.849C205.484 173.082 203.579 175.942 203.579 175.942L203.641 173.814Z",
    fill: "url(#paint14_linear_3079_14443)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M203.579 175.942C203.579 175.942 206.707 166.203 216.07 166.918",
    stroke: "url(#paint15_linear_3079_14443)",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M204.849 166.476C204.849 166.476 207.11 156.95 201.4 154.826C195.689 152.702 193.235 153.95 192.352 154.075C191.467 154.2 193.481 155.154 194.843 157.348C196.205 159.543 195.65 161.725 199.516 163.433C203.383 165.141 204.156 168.489 204.156 168.489L204.849 166.476Z",
    fill: "url(#paint16_linear_3079_14443)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M204.156 168.487C204.156 168.487 204.667 158.271 195.653 155.637",
    stroke: "url(#paint17_linear_3079_14443)",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0509 61.2449C58.0509 59.9973 57.0399 58.9863 55.7923 58.9863H22.4591C21.2116 58.9863 20.2005 59.9973 20.2005 61.2449V79.2572C20.2005 80.5048 21.2116 81.5158 22.4591 81.5158H49.9311L52.5166 85.0395C53.3221 86.1375 54.7153 86.0357 55.3529 84.8326L57.5879 80.6133C57.8744 80.2345 58.0509 79.7681 58.0509 79.2565V61.2449Z",
    fill: "url(#paint18_linear_3079_14443)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7233 67.0596H26.2134C25.815 67.0596 25.4922 66.7367 25.4922 66.3384C25.4922 65.94 25.815 65.6172 26.2134 65.6172H51.7233C52.1216 65.6172 52.4445 65.94 52.4445 66.3384C52.4445 66.736 52.1216 67.0596 51.7233 67.0596Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9702 70.4365H26.2134C25.815 70.4365 25.4922 70.1137 25.4922 69.7153C25.4922 69.317 25.815 68.9941 26.2134 68.9941H43.9702C44.3685 68.9941 44.6914 69.317 44.6914 69.7153C44.6914 70.1137 44.3685 70.4365 43.9702 70.4365Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2778 73.8857H26.2134C25.815 73.8857 25.4922 73.5629 25.4922 73.1646C25.4922 72.7662 25.815 72.4434 26.2134 72.4434H48.2778C48.6761 72.4434 48.999 72.7662 48.999 73.1646C48.9996 73.5629 48.6761 73.8857 48.2778 73.8857Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.995 177.59C151.059 188.599 142.185 197.576 131.176 197.64C120.166 197.703 111.19 188.83 111.127 177.82C111.064 166.81 119.936 157.834 130.946 157.77C141.956 157.707 150.932 166.581 150.995 177.59Z",
    fill: "#9FCCFB"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M149.486 177.41C150.101 166.306 141.598 156.806 130.494 156.191C119.39 155.576 109.889 164.079 109.274 175.183C108.659 186.287 117.163 195.788 128.267 196.403C139.371 197.018 148.871 188.514 149.486 177.41Z",
    fill: "#B4D8F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M144.362 175.901C144.411 184.356 137.598 191.248 129.143 191.297C120.688 191.345 113.796 184.532 113.747 176.078C113.699 167.623 120.512 160.73 128.966 160.682C137.421 160.633 144.314 167.446 144.362 175.901Z",
    fill: "#71B7E2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.798 176.535C144.846 184.876 138.124 191.676 129.783 191.724C121.442 191.771 114.642 185.049 114.594 176.709C114.547 168.368 121.268 161.568 129.609 161.52C137.95 161.472 144.75 168.194 144.798 176.535Z",
    fill: "#FF725E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M144.798 176.535C144.846 184.876 138.124 191.676 129.783 191.724C121.442 191.771 114.642 185.049 114.594 176.709C114.547 168.368 121.268 161.568 129.609 161.52C137.95 161.472 144.75 168.194 144.798 176.535Z",
    fill: "#8CC2F2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M130.29 175.31L130.268 171.447C130.274 171.446 130.28 171.447 130.287 171.447C130.958 171.52 131.654 171.695 132.343 171.97C132.919 172.264 133.308 172.572 133.308 172.572L133.359 172.452L133.946 171.057L134.082 170.737L133.389 170.018L133.059 170.169C132.212 169.751 131.248 169.425 130.256 169.377L130.243 167.252L129.579 166.723L129.582 167.256L128.674 167.261L128.687 169.424C125.703 169.728 124.296 171.44 124.307 173.393C124.322 176.054 126.604 176.73 128.732 177.234L128.754 181.062C127.298 180.937 125.859 180.39 124.917 179.629L124.067 181.568C125.067 182.424 126.89 183.026 128.766 183.129L128.775 184.734L128.028 184.751L128.778 185.254L130.348 185.245L130.336 183.101C133.339 182.778 134.765 181.084 134.754 179.132C134.738 176.472 132.418 175.814 130.29 175.31ZM128.718 174.917C127.606 174.598 126.78 174.182 126.775 173.263C126.77 172.421 127.34 171.729 128.699 171.51L128.718 174.917ZM130.268 171.443C130.268 171.443 130.268 171.443 130.268 171.443V171.443ZM130.323 181.015L130.303 177.627C131.454 177.946 132.298 178.381 132.304 179.319C132.309 180.142 131.719 180.796 130.323 181.015Z",
    fill: "#71B7E2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M129.683 182.579L129.695 184.724L128.125 184.733L128.113 182.608C126.236 182.503 124.413 181.901 123.413 181.045L124.264 179.107C125.206 179.867 126.645 180.414 128.102 180.54L128.079 176.711C125.952 176.206 123.669 175.53 123.654 172.869C123.642 170.916 125.05 169.204 128.034 168.9L128.021 166.736L129.591 166.727L129.603 168.852C131.021 168.92 132.459 169.333 133.497 169.998L132.723 171.935C131.706 171.348 130.631 171.029 129.615 170.92L129.638 174.787C131.766 175.292 134.086 175.948 134.102 178.61C134.114 180.563 132.687 182.256 129.683 182.579ZM128.066 174.394L128.046 170.986C126.688 171.205 126.118 171.898 126.123 172.74C126.128 173.659 126.954 174.075 128.066 174.394ZM131.652 178.796C131.647 177.858 130.802 177.422 129.651 177.104L129.671 180.493C131.068 180.274 131.658 179.62 131.652 178.796Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M144.632 170.052C149.162 170.052 152.834 166.379 152.834 161.849C152.834 157.319 149.162 153.646 144.632 153.646C140.101 153.646 136.429 157.319 136.429 161.849C136.429 166.379 140.101 170.052 144.632 170.052Z",
    fill: "#E4F1FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M141.86 161.674L142.961 164.143C143.072 164.393 143.404 164.448 143.589 164.246L147.702 159.775",
    stroke: "url(#paint19_linear_3079_14443)",
    strokeWidth: 1.02692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M144.609 168.626C148.364 168.626 151.408 165.582 151.408 161.827C151.408 158.072 148.364 155.027 144.609 155.027C140.853 155.027 137.809 158.072 137.809 161.827C137.809 165.582 140.853 168.626 144.609 168.626Z",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2413 98.8787C36.2413 98.8787 38.7278 91.9957 49.212 94.9741C56.2008 96.9591 60.2631 102.506 59.8007 110.652C59.3127 119.258 64.7526 116.617 61.5855 129.053C59.4441 137.462 69.6177 144.391 60.3628 157.598C52.8692 168.292 10.4887 162.132 10.9147 143.68C11.1156 134.967 18.3922 139.041 18.831 124.987C19.017 119.021 30.3808 121.012 28.8522 111.965C28.0905 107.458 31.6985 98.3064 36.2413 98.8787Z",
    fill: "#010407"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0758 125.658C49.0758 125.658 51.9579 127.427 51.2421 131.287C50.5263 135.146 50.2088 138.788 53.5061 141.605",
    stroke: "#01060B",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7845 116.678C57.4929 119.781 58.8328 121.855 56.9827 126.067C53.0768 134.959 60.8811 136.811 57.135 144.954C55.7917 147.873 55.2498 150.394 54.9728 152.592",
    stroke: "#01060B",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M58.45 160.661L71.8352 160.663L67.7318 156.184L58.9501 157.511L58.45 160.661Z",
    fill: "#F7C2A0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.127 121.674C34.127 121.674 30.2925 123.801 30.8068 127.837C31.5004 133.281 26.0833 134.131 27.4314 137.537",
    stroke: "#01060B",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4042 107.117C32.4042 107.117 30.8526 110.505 31.2591 113.922C32.0915 120.925 22.5839 121.075 22.5124 128.142C22.4679 132.56 18.7818 135.258 16.3884 137.821",
    stroke: "#01060B",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7589 240.965L97.732 249.13L90.1972 249.19L89.0042 242.534L97.7589 240.965Z",
    fill: "#E8977B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2409 243.525L74.5035 252.433L66.3595 253.171L65.0276 246.472L75.2409 243.525Z",
    fill: "#E8977B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6254 183.243C50.2837 187.892 68.3108 197.101 78.5369 198.957C79.3767 199.109 80.0312 199.767 80.1552 200.611L86.3857 243.042C86.4969 243.8 87.0355 244.426 87.7715 244.644C90.1386 245.343 95.5031 246.239 99.6557 241.802C100.035 241.397 100.237 240.856 100.198 240.302C99.7669 234.042 96.9131 193.59 94.858 188.285C92.7666 182.883 63.5523 177.203 59.9928 176.53C59.7583 176.486 59.519 176.485 59.2838 176.527L42.2091 179.57C40.3704 179.897 39.9794 182.36 41.6254 183.243Z",
    fill: "url(#paint20_linear_3079_14443)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.086 185.973C29.1265 185.984 22.0851 199.248 57.352 202.365C58.1298 202.434 58.7081 203.12 58.7877 203.897L63.1707 246.701C63.2402 247.379 63.6971 247.949 64.3428 248.168C66.5496 248.912 71.8109 250.022 76.5411 245.945C76.9583 245.585 77.2057 245.069 77.1908 244.519C77.019 238.267 75.8381 197.707 74.0041 192.319C72.2396 187.136 46.2672 180.703 40.4525 179.322C39.7576 179.157 39.0385 179.436 38.632 180.023L29.086 185.973Z",
    fill: "url(#paint21_linear_3079_14443)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4536 131.627C38.4622 128.352 51.8022 131.195 53.988 131.85C56.4825 132.598 59.6005 135.591 62.9678 142.327C66.3352 149.062 66.3352 149.062 66.3352 149.062L59.6005 151.058V176.75C53.5876 181.858 46.3542 185.321 38.6051 186.801L29.5066 188.429C28.6243 188.587 27.8216 187.891 27.8519 186.995L28.8939 154.303L17.4647 154.905C17.4647 154.905 16.9343 134.757 27.4536 131.627Z",
    fill: "#FFFEFC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2197 155.368L29.6987 161.011L28.894 154.303L19.3554 154.733C19.3554 154.733 17.206 171.307 22.8778 171.661C31.4673 172.198 53.6025 161.325 53.6025 161.325L50.2197 155.368Z",
    fill: "#F7C2A0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9258 103.691C48.0756 103.227 49.7445 103.598 50.5924 104.476C52.9204 106.888 55.8227 111.102 54.8386 116.483C53.7009 122.706 52.2255 126.579 48.7955 126.515C47.682 126.494 47.1967 127.377 47.161 128.422L46.9494 131.675C45.9356 137.364 37.613 138.187 35.2324 132.833L34.8421 131.955C34.5563 131.313 34.5671 130.581 34.8697 129.946C35.8727 127.844 38.3146 124.265 35.5795 116.328C35.3921 115.785 34.5577 113.928 35.0895 112.622C35.5431 111.507 36.9922 111.343 37.9136 112.117C38.1164 112.287 38.3914 112.318 38.9064 111.96C40.6898 110.72 40.8469 106.143 46.9258 103.691Z",
    fill: "#F7C2A0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6658 103.529C47.6658 103.529 47.7622 105.627 51.2556 107.428C55.5281 109.631 52.8995 112.267 54.8757 115.385C56.957 118.668 55.1493 112.413 55.1493 112.413L54.5434 105.278C53.3369 100.648 51.5663 97.621 47.1246 98.5478C44.7419 99.0452 42.4382 99.9423 41.2014 101.542C37.9439 105.756 37.2314 115.356 37.2314 115.356C37.2314 115.356 40.8118 115.426 42.6943 110.928C44.8242 105.842 44.5741 105.024 47.6658 103.529Z",
    fill: "#010407"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9697 161.127H59.7993C59.1287 161.127 58.5848 160.583 58.5848 159.912V142.187C58.5848 141.517 59.1287 140.973 59.7993 140.973H67.9697C68.6403 140.973 69.1843 141.517 69.1843 142.187V159.912C69.1843 160.583 68.6403 161.127 67.9697 161.127Z",
    fill: "url(#paint22_linear_3079_14443)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0139 154.469C72.7964 151.374 69.7 145.558 68.6466 145.439C68.0811 145.375 67.8971 145.872 68.1471 147.047C68.8912 150.539 70.0937 151.221 66.8254 150.66C66.3536 150.579 63.9561 150.112 62.6431 149.855C61.678 149.666 60.8321 150.628 61.2237 151.53C61.3302 151.775 61.5047 152.043 61.771 152.332C61.771 152.332 60.9986 154.506 63.0657 155.046C63.0657 155.046 63.3084 157.515 64.8627 157.626C64.8627 157.626 66.5174 158.655 70.0006 160.095C71.5852 161.154 73.7138 160.842 74.9283 159.374L75.1939 159.052C76.3101 157.701 76.2325 155.728 75.0139 154.469Z",
    fill: "#F7C2A0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1328 152.357C63.278 152.717 65.0351 153.255 66.1297 153.203",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3427 155.09C63.3427 155.09 65.3654 155.865 66.8071 155.756",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2197 155.368L52.7108 153.562C54.5084 149.982 57.8205 143.498 58.4217 143.812C59.0836 144.156 59.2595 144.881 58.8119 146.302C57.7396 149.707 58.268 151.377 60.1997 151.231C60.8643 151.181 66.5739 151.146 66.5739 151.146C66.5739 151.146 67.9407 152.369 66.1236 153.753C66.1236 153.753 66.5078 156.028 64.3779 156.201C64.3779 156.201 63.7107 158.591 62.1604 158.431C62.1604 158.431 60.3521 159.158 56.672 159.972L53.6012 161.325L50.2197 155.368Z",
    fill: "#F7C2A0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M65.763 153.715C64.5734 153.87 62.7488 154.096 61.6805 153.855",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0975 156.197C64.0975 156.197 61.971 156.61 60.5704 156.253",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4218 143.811C59.0837 144.155 59.2596 144.88 58.812 146.301C57.7397 149.706 58.2681 151.376 60.1998 151.229C60.8644 151.179 66.5739 151.145 66.5739 151.145C66.5739 151.145 67.9408 152.368 66.1237 153.752C66.1237 153.752 66.5079 156.027 64.378 156.2C64.378 156.2 63.7107 158.59 62.1605 158.43C62.1605 158.43 60.3521 159.156 56.6721 159.971",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8634 157.625C65.6736 158.023 68.6561 159.539 70.0014 160.095",
    stroke: "#F18884",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4788 247.723C98.4788 247.723 96.0685 249.675 89.2664 248.631C89.2664 248.631 88.7865 252.888 86.935 255.113C85.0828 257.337 90.45 260.025 94.4759 258.778C98.5024 257.53 101.509 260.5 105.489 260.017C109.469 259.533 115.208 255.203 113.08 253.912C110.952 252.621 103.388 252.67 101.504 249.714C100.393 247.971 98.4788 247.723 98.4788 247.723Z",
    fill: "url(#paint23_linear_3079_14443)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M103.553 258.362C107.201 259.446 111.274 255.213 111.274 255.213",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5918 255.82C88.5918 255.82 90.0395 257.548 93.3664 257.206C96.694 256.864 99.9057 257.278 103.553 258.361",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4256 250.807C75.4256 250.807 71.635 253.502 64.9023 252.08C64.9023 252.08 64.9933 256.129 63.0198 258.247C61.0463 260.365 66.2544 263.349 70.3443 262.328C74.4342 261.307 77.2704 264.441 81.2706 264.18C85.2709 263.92 91.244 259.918 89.1916 258.51C87.1393 257.102 78.8388 256.159 77.1221 253.102C76.1098 251.299 75.4256 250.807 75.4256 250.807Z",
    fill: "url(#paint24_linear_3079_14443)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4306 262.421C83.0109 263.707 87.3151 259.709 87.3151 259.709",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6348 259.049C64.6348 259.049 65.9834 260.855 69.3245 260.699C72.6656 260.544 75.8496 261.136 79.4306 262.422",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M75.127 200.359C74.788 196.451 74.4126 193.517 74.0048 192.319C72.9924 189.346 64.0159 185.962 55.4473 183.355",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8891 221.446C74.629 215.319 74.3075 208.872 73.9314 203.434",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7796 247.322C70.0005 247.21 72.5651 246.484 74.9902 244.394C75.4074 244.034 75.6547 243.518 75.6399 242.967C75.5847 240.951 75.4242 235.366 75.1708 228.543",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 192.053C65.2373 192.053 65.4577 197.68 71.9679 199.666",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5248 187.309C87.5248 187.309 88.8485 192.494 94.3653 195.363",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0042 242.535C89.0042 242.535 94.1442 242.696 98.3372 239.496",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5621 132.676C33.5621 132.676 34.7208 139.425 43.3778 137.664",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9287 133.15C47.9287 133.15 48.0042 135.031 45.5218 136.535",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0447 153.296L26.204 153.234",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9573 154.165L29.7095 149.375",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8358 183.643C37.0987 184.383 34.0292 185.004 30.6248 185.411",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9665 175.355C56.9665 175.355 52.8423 179.144 44.4603 182.184",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0044 178.102C44.1933 178.788 42.3014 179.261 40.4532 179.322",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8661 171.436C56.8661 171.436 53.7265 174.222 49.5173 176.484",
    stroke: "#315782",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M41.074 188.301C41.074 188.301 43.3913 193.266 39.5292 196.907",
    stroke: "white",
    strokeWidth: 0.337005,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3079_14443",
    x1: 14.265,
    y1: 220.172,
    x2: 14.5376,
    y2: 229.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3079_14443",
    x1: 85.2756,
    y1: 52.9084,
    x2: 217.117,
    y2: 62.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3079_14443",
    x1: 109.383,
    y1: 45.787,
    x2: 156.721,
    y2: 68.5543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3079_14443",
    x1: 222.472,
    y1: 106.657,
    x2: 264.23,
    y2: 127.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3079_14443",
    x1: 175.011,
    y1: 83.116,
    x2: 196.268,
    y2: 94.9418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3079_14443",
    x1: 109.946,
    y1: 127.969,
    x2: 119.483,
    y2: 142.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3079_14443",
    x1: 180.158,
    y1: 127.969,
    x2: 190.326,
    y2: 136.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3079_14443",
    x1: 188.613,
    y1: 57.6943,
    x2: 204.994,
    y2: 81.6095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3079_14443",
    x1: 188.613,
    y1: 9.64938,
    x2: 204.994,
    y2: 33.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3079_14443",
    x1: 203.157,
    y1: 179.633,
    x2: 235.073,
    y2: 185.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3079_14443",
    x1: 203.215,
    y1: 182.948,
    x2: 226.995,
    y2: 186.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3079_14443",
    x1: 185.142,
    y1: 175.067,
    x2: 211.112,
    y2: 178.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3079_14443",
    x1: 189.749,
    y1: 177.669,
    x2: 208.22,
    y2: 179.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3079_14443",
    x1: 202.419,
    y1: 163.459,
    x2: 208.285,
    y2: 163.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3079_14443",
    x1: 204.216,
    y1: 164.798,
    x2: 226.477,
    y2: 169.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3079_14443",
    x1: 204.068,
    y1: 167.392,
    x2: 221.135,
    y2: 170.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3079_14443",
    x1: 192.649,
    y1: 154.438,
    x2: 211.04,
    y2: 156.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3079_14443",
    x1: 195.986,
    y1: 156.362,
    x2: 207.964,
    y2: 157.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3079_14443",
    x1: 21.6807,
    y1: 60.5002,
    x2: 73.3041,
    y2: 71.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3079_14443",
    x1: 142.089,
    y1: 160.035,
    x2: 150.117,
    y2: 161.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3079_14443",
    x1: 42.9165,
    y1: 180.376,
    x2: 126.308,
    y2: 190.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3079_14443",
    x1: 30.4409,
    y1: 183.205,
    x2: 98.8686,
    y2: 190.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3079_14443",
    x1: 58.9993,
    y1: 142.11,
    x2: 73.9726,
    y2: 143.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3079_14443",
    x1: 87.6132,
    y1: 248.42,
    x2: 122.461,
    y2: 259.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3079_14443",
    x1: 63.6451,
    y1: 251.562,
    x2: 99.0172,
    y2: 261.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2977CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D538F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceImg1);
export default __webpack_public_path__ + "static/media/InvoiceImg1.4e945342876a4973dffdbe23eb81402c.svg";
export { ForwardRef as ReactComponent };